import orders from './columns/orders';
import jobs from './columns/jobs';
import titles from './columns/titles';
import tasks from './columns/tasks';
import processingTasks from './columns/processingTasks';
import pendingAssets from './columns/pendingAssets';
import fileIngest from './columns/fileIngest';
import theme from './theme';
import jobDetails from './jobDetails';
import dataConfig from './dataConfig';
import dashboardConfig from './dashboardConfig';
import taskConfig from './taskConfig';
import titleConfig from './titleConfig';
import orderPlacementConfig from './orderPlacementConfig';
import { AllTableColumnsConfig, ClientConfig } from '@/__configs/config_types';
import { DeepPartial } from '@/redux/slices/slice_types';
import TitleHierarchy from '../components/TitleHierarchy';

const config: DeepPartial<ClientConfig> = {
  clientName: 'PBS',
  theme,
  columns: { orders, jobs, processingTasks, tasks, titles, pendingAssets, fileIngest } as DeepPartial<AllTableColumnsConfig<unknown>>,
  jobDetails,
  dataConfig,
  taskConfig,
  dashboardConfig,
  orderPlacementConfig,
  titleConfig,
  ingestManagementConfig: {
    version: 'v2',
    disableRecentTitles: true,
    chart: {
      colors: ['primary', 'secondary', 'default'],
      glow: {
        opacity: 0.1,
        color: 'tertiary'
      }
    },
    registerAgainstWhiteList: ['version'],
    disableReadyToRegisterForImages: true
  },
  userColors: ['#aa6600', '#118833', '#6e2a9f', '#952a9f', '#cc4455', '#71a400', '#667799', '#bb44aa', '#8855ee', '#5566ee', '#4466ff', '#dd2277'],
  versionColors: {
    shortened: '#72A73C',
    pledge: '#B16BE9',
    original: '#5566ee'
  },
  enableUserDocumentation: true,
  disableJobDetailProxy: false,
  notifications: true,
  commonConstants: {
    fileTypeGrouping: {
      video: ['mov', 'mxf', 'mp4', 'avi', 'mpg', 'mpeg'],
      audio: ['wav', 'aac', 'mp3'],
      subtitle: ['srt', 'scc', 'vtt', 'webvtt', 'sub', 'ass', 'ssa', 'ttml', 'dfxp', 'itt', 'stl'],
      image: ['jpg', 'jpeg', 'bmp', 'png', 'gif', 'svg', 'tiff', 'tif'],
      other: ['pdf', 'prproj', 'xml', 'csv', 'xls', 'xlsx', 'txt', 'doc', 'docx', 'json'],
      captions: []
    }
  },
  bulkActionIcons: {
    cancel_job: 'cancel',
    restart_job: 'refresh',
    retry_rally_job: 'reset'
  },
  titleHierarchyComponent: TitleHierarchy
};

export default config;
